<template>
    <div style="width: 100%;">
        <div class="d-flex col-12">
            <div class="form-control-label" style="white-space: pre-line;margin-left: 4px;"><span v-if="question.is_required" class="required-star mr-1">*</span>{{title}}</div>
        </div>
        <div class="col-12" v-if="question.image_file_name">
            <img class="cursor-pointer" :src="this.context.storageEndpoint + this.question.image_file_name" @click="openPhotoViewer = true"/>
        </div>
        <div class="col-12"><p class="text-muted px-1 question-description" v-html="formattedText"></p></div>
        <div v-if="!hasValidAnswer && showInvalid"
            class="col-12 pl-3">
            <div class="alert alert-warning">{{$t('message.please_fill_your_answer')}}</div>
        </div>
        <div class="mt-1 mb-3">
            <editable-text
                :onChange="this.onAnswerChange"
                :doneOnBlur="true"
                :text="this.text"
                :outerWrapperClass="'answer-outer-wrapper ml-3 mr-3'"
                :editInputClass="'form-control'"
                :doneButtonClass="'btn btn-primary btn-block mt-1 btn-sm'"
                :placeholder="$t('message.click_to_enter')"
                :useTextarea="adminQuestion.answer_type === Constants.Question.AnswerType.Paragraph" />
        </div>
        <photo-viewer
            v-if="openPhotoViewer"
            ref="photoViewer"
            :photos="photo"
            :context="context"
            @close="openPhotoViewer = false"></photo-viewer>
    </div>
</template>

<script>
import Constants from '../../constants';
import PhotoViewer from '../common/PhotoViewer.vue';

export default {
    components: { PhotoViewer },
    props: ['question', 'providerId', 'context', 'answer'],
    data() {
        return {
            id: this.question.id,
            content: this.question.content,
            status: this.question.status,
            adminQuestion: this.question.question,
            Constants,
            text: this.answer ? this.answer.content : '',
            showInvalid: false,
            openPhotoViewer: false
        };
    },

    computed: {
        title: function() {
            return this.content.meta.title || '';
        },

        photo() {
            if (this.question.image_file_name) {
                return [{
                    path: this.question.image_file_name
                }];
            } else {
                return [];
            }
        },

        hasAnswer() {
            return this.text.length > 0;
        },

        hasValidAnswer() {
            return this.text.length > 0;
        },
        formattedText() {
            const text = this.content.data.text;
            return text.nl2brIfNotHTML();
        }
    },

    methods: {
        onAnswerChange(newAnswer) {
            this.text = newAnswer;
        },

        highlightInvalidState() {
            this.showInvalid = true;
        },

        getDataToPersist() {
            return {
                question_id: this.id,
                answer: this.text,
                answer_id: this.answer ? this.answer.id : null
            };
        }
    }
}
</script>

<style scoped>
.required-star {
    color: red;
    font-weight: bold;
}

textarea {
    margin: 1em auto;
    width: 96%;
}

.answer-outer-wrapper {
    min-width: 30%;
    background: #EEE;
    border-radius: 4px;
    padding: 1em;
    cursor: pointer;
}

img {
    max-width: max-content;
    width: 100%;
    border-radius: 4px;
}
</style>
